module.exports = __webpack_public_path__ + "static/media/no-template.78e40aa9.svg";